import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
export const useFetchLanguages = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("language/list");
    }, options);
};